import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-fill text-2xl text-accent-500"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                黄瓜影院
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              海量高清影视资源免费在线观看平台。最新电影、热门电视剧、精彩综艺、优质动漫，尽在黄瓜影院。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              影视分类
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer"
                >
                  联系方式
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer"
                >
                  使用条款
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer"
                >
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              关注我们
            </h4>
            <p className="text-sm text-background-400 mb-3">
              获取最新影视资讯和观影推荐
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-accent-500 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-accent-500 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-accent-500 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="py-5 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 黄瓜影院 huanggua.tv · 本站所有资源均来自互联网，仅供学习交流使用
          </p>
          <p className="text-xs text-background-500">
            <a href="#" className="hover:text-accent-400 transition-colors duration-200">京ICP备2024000001号</a>
          </p>
        </div>
      </div>
    </footer>
  );
}